<div class="cx_buttonImg__container">
  <div  [ngClass]="{'cx_buttonImg__container__content': isConnected, 'cx_buttonImg__container__content__offline': !isConnected}">
    <img src="{{ icon }}" alt="" *ngIf="isConnected" />
    <button>
      {{ messageText }}
    </button>
  </div>
</div>
